// Keys of the operation dialogs (order, receipt, ...). Not a page bundle —
// spread into the `Warehouses` locale, where the dialogs live.
export const WAREHOUSE_OPERATIONS = {
  en: {
    'Goods receipt': 'Goods receipt',
    'Set prices': 'Set prices',
    'Products count': 'Products',
    'Check all': 'Check all',
    'Uncheck all': 'Uncheck all',
    'Purchase Price': 'Purchase Price',
    'Sale Price': 'Sale Price',
    'In Stock': 'In Stock',
    'Waybill №': 'Waybill №',
    'Document date': 'Document date',
    'Below critical quantity': 'Below critical quantity',
    'From waybill': 'From waybill',
    Product: 'Product',
    Packages: 'Packages',
    Quantity: 'Quantity',
    Sum: 'Sum',
    'Total sum': 'Total sum',
    Notes: 'Notes',
    Save: 'Save',
    Order: 'Order',
    'A waybill with this number already exists':
      'A waybill with this number already exists',
    'Enter packages for at least one product':
      'Enter packages for at least one product',
    'No waybills yet': 'No waybills yet',
    'Check categories on the left':
      'Check folders on the left — their products will appear here',
    'Nothing found': 'Nothing found',
    'Some products are not available here':
      'Some products from that waybill are not available here and were skipped',
    'No categories': 'No folders',
    'No products': 'No products',
    Supplier: 'Supplier',
    'To warehouse': 'To warehouse',
    'Goods on consignment': 'Goods on consignment',
    Currency: 'Currency',
    Discount: 'Discount',
    'Transport costs': 'Transport costs',
    Payment: 'Payment',
    'Pay later': 'Pay later',
    Remind: 'Remind',
    'Remind in': 'In',
    Units: 'Units',
    reminder_day: 'day(s)',
    reminder_week: 'week(s)',
    reminder_month: 'month(s)',
    'To pay': 'To pay',
    Post: 'Post',
    'Change payment price': 'Change payment price',
    'Select a supplier': 'Select a supplier',
    'Select a warehouse': 'Select a warehouse',
    'Select the destination warehouse': 'Select the destination warehouse',
    'Select supplier to see consignment products':
      'Select a supplier to see their consignment products',
    'Price setting': 'Price setting',
    'Portion Price': 'Portion Price',
    'Unit Price': 'Unit Price',
    'Editable when the product is sold by packages':
      'Editable when the product card has "Sale by packages" enabled',
    'Editable when the product is sold by portions':
      'Editable when the product card has "Sale by portions" enabled',
    'A kit has no purchase price of its own':
      'A kit has no purchase price of its own — it is made up of components',
    Kit: 'Kit',
    Saved: 'Saved',
    'Transfer between warehouses': 'Transfer between warehouses',
    'From warehouse': 'From warehouse',
    Move: 'Move',
    'Source and destination must differ':
      'Source and destination warehouses must differ',
    'Not enough stock on the source warehouse':
      'Not enough stock on the source warehouse',
    'Goods write-off': 'Goods write-off',
    'Write off': 'Write off',
    'Not enough stock in the warehouse': 'Not enough stock in the warehouse',
    'Return to supplier': 'Return to supplier',
    'To supplier': 'To supplier',
    Return: 'Return',
    'Per unit': 'Per unit',
    'Credit with supplier': 'Credit against future operations',
    'Inventory as of': 'Inventory as of',
    'Previous inventory': 'Previous inventory',
    'Opening balance': 'Opening balance',
    Receipts: 'Receipts',
    Transfers: 'Transfers',
    'Write-offs': 'Write-offs',
    'Supplier returns': 'Supplier returns',
    'Expense (plan)': 'Expense (plan)',
    'Actual (packages)': 'Actual at period end — packages',
    'Actual (units)': 'Actual at period end',
    'Stock value': 'Stock value',
    Discrepancy: 'Discrepancy (actual − plan)',
    'Discrepancy sum': 'Discrepancy sum',
    'Price per unit': 'Price per unit',
    'Discrepancy at sale price': 'Discrepancy sum at sale price',
    'Sale price per unit': 'Sale price per unit',
    'Save inventory': 'Save inventory',
    'No discrepancies found': 'No discrepancies found',
    Base: 'Base',
    'No products on the warehouse': 'No products — the warehouse has no stock',
    'No consignment products on the warehouse':
      'No consignment products of this supplier on the warehouse',
  },
  uk: {
    'Goods receipt': 'Прихід товарів',
    'Set prices': 'Встановити ціни',
    'Products count': 'Товарів',
    'Check all': 'Позначити всі',
    'Uncheck all': 'Зняти всі',
    'Purchase Price': 'Ціна закупки',
    'Sale Price': 'Ціна продажу',
    'In Stock': 'На складі',
    'Waybill №': 'Накладна №',
    'Document date': 'Дата документа',
    'Below critical quantity': 'Нижче критичної кількості',
    'From waybill': 'З накладної',
    Product: 'Товар',
    Packages: 'Упаковки',
    Quantity: 'Кількість',
    Sum: 'Сума',
    'Total sum': 'Загальна сума',
    Notes: 'Примітки',
    Save: 'Зберегти',
    Order: 'Замовити',
    'A waybill with this number already exists':
      'Накладна з таким номером уже існує',
    'Enter packages for at least one product':
      'Введіть упаковки хоча б для одного товару',
    'No waybills yet': 'Накладних ще немає',
    'Check categories on the left':
      'Позначте папки ліворуч — їхні товари зʼявляться тут',
    'Nothing found': 'Нічого не знайдено',
    'Some products are not available here':
      'Деякі товари з тієї накладної недоступні тут — їх пропущено',
    'No categories': 'Немає папок',
    'No products': 'Немає товарів',
    Supplier: 'Постачальник',
    'To warehouse': 'На склад',
    'Goods on consignment': 'Товар під реалізацію',
    Currency: 'Валюта',
    Discount: 'Знижка',
    'Transport costs': 'Транспортні витрати',
    Payment: 'Оплата',
    'Pay later': 'Сплатити пізніше',
    Remind: 'Нагадати',
    'Remind in': 'Через',
    Units: 'Одиниці',
    reminder_day: 'дн.',
    reminder_week: 'тиж.',
    reminder_month: 'міс.',
    'To pay': 'До сплати',
    Post: 'Оприбуткувати',
    'Change payment price': 'Змінити ціну оплати',
    'Select a supplier': 'Оберіть постачальника',
    'Select a warehouse': 'Оберіть склад',
    'Select the destination warehouse': 'Оберіть склад-приймач',
    'Select supplier to see consignment products':
      'Оберіть постачальника, щоб побачити його товари під реалізацію',
    'Price setting': 'Встановлення цін',
    'Portion Price': 'Ціна порції',
    'Unit Price': 'Ціна за одиницю',
    'Editable when the product is sold by packages':
      'Активна, якщо в картці товару увімкнено «Продаж по упаковкам»',
    'Editable when the product is sold by portions':
      'Активна, якщо в картці товару увімкнено «Продаж по порціям»',
    'A kit has no purchase price of its own':
      'Набір не має власної ціни закупки — вона складається з компонентів',
    Kit: 'Набір',
    Saved: 'Збережено',
    'Transfer between warehouses': 'Переміщення між складами',
    'From warehouse': 'Зі складу',
    Move: 'Перемістити',
    'Source and destination must differ':
      'Склад-джерело та склад-отримувач мають відрізнятися',
    'Not enough stock on the source warehouse':
      'Недостатньо залишку на складі-джерелі',
    'Goods write-off': 'Списання товарів',
    'Write off': 'Списати',
    'Not enough stock in the warehouse': 'Недостатньо залишку на складі',
    'Return to supplier': 'Повернення постачальнику',
    'To supplier': 'Постачальнику',
    Return: 'Повернути',
    'Per unit': 'За одиницю',
    'Credit with supplier': 'В рахунок наступних операцій',
    'Inventory as of': 'Інвентаризація на',
    'Previous inventory': 'Попередня інвентаризація',
    'Opening balance': 'На початок періоду',
    Receipts: 'Прихід',
    Transfers: 'Переміщення',
    'Write-offs': 'Списання',
    'Supplier returns': 'Повернення постачальнику',
    'Expense (plan)': 'Витрата (план)',
    'Actual (packages)': 'На кінець періоду (факт) — упаковки',
    'Actual (units)': 'На кінець періоду (факт)',
    'Stock value': 'Сума залишків',
    Discrepancy: 'Розбіжність (факт − план)',
    'Discrepancy sum': 'Сума розбіжності',
    'Price per unit': 'Ціна за од.',
    'Discrepancy at sale price': 'Сума розбіжності за ціною продажу',
    'Sale price per unit': 'Ціна за од. (продаж)',
    'Save inventory': 'Зберегти інвентаризацію',
    'No discrepancies found': 'Розбіжностей не виявлено',
    Base: 'База',
    'No products on the warehouse': 'Немає товарів — на складі немає залишків',
    'No consignment products on the warehouse':
      'Немає товарів цього постачальника під реалізацію на складі',
  },
};
